module.exports = __webpack_public_path__ + "img/aboutBewincoin.792bf2ff.svg";